import { render } from "./BookDetail.vue?vue&type=template&id=0b3ee634"
import script from "./BookDetail.vue?vue&type=script&lang=js"
export * from "./BookDetail.vue?vue&type=script&lang=js"

import "./BookDetail.vue?vue&type=style&index=0&id=0b3ee634&lang=scss"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__